import { useLocation, Link, Outlet } from 'react-router';
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarInset,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarProvider
} from '@/components/ui/sidebar';
import { superAdminMenuItems } from '@/config/super-admin-menu.config';
import { AbilityContext } from '@/lib/ability-context';
import { usePermissions } from '@/hooks/use-permissions';
import { SidebarUserMenu } from './sidebar-user-menu';

export default function SuperAdminLayout() {
	const location = useLocation();
	const { ability } = usePermissions();

	const isItemActive = (path: string) =>
		location.pathname === path || location.pathname.startsWith(path + '/');

	const isMenuItemActive = (item: (typeof superAdminMenuItems)[0]) => {
		if (item.activePrefix) return location.pathname.startsWith(item.activePrefix);
		if (item.subItems) return item.subItems.some((s) => isItemActive(s.path));
		return isItemActive(item.path);
	};

	return (
		<AbilityContext.Provider value={ability}>
			<SidebarProvider defaultOpen={false}>
				<Sidebar collapsible='icon'>
					<SidebarHeader>
						<Link to='/super-admin/accounts'>
							<div className='flex shrink-0 items-center justify-center rounded-lg'>
								<img src='/assets/brand/kim-ai-logo.svg' className='h-9 w-9' alt='Kim AI Logo' />
							</div>
						</Link>
					</SidebarHeader>
					<SidebarContent>
						<SidebarMenu>
							{superAdminMenuItems.map((item) => {
								const active = isMenuItemActive(item);

								return (
									<SidebarMenuItem key={item.path}>
										<SidebarMenuButton asChild tooltip={item.label} isActive={active}>
											<Link to={item.path}>
												<item.icon />
												<span>{item.label}</span>
											</Link>
										</SidebarMenuButton>
									</SidebarMenuItem>
								);
							})}
						</SidebarMenu>
					</SidebarContent>
					<SidebarFooter className='px-0 pb-3'>
						<SidebarUserMenu />
					</SidebarFooter>
				</Sidebar>
				<SidebarInset>
					<div className='flex flex-1 flex-col p-0'>
						<Outlet />
					</div>
				</SidebarInset>
			</SidebarProvider>
		</AbilityContext.Provider>
	);
}
